import axios from "axios";
import host from "../../../global.jsx";
const api = axios.create({ baseURL: host, withCredentials: true });
// Request interceptor
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("accessToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
export const adminDashboardService = {
  // Get admin profile details
  getAdminProfile: async () => {
    const response = await api.get("/getadmindetails");
    return response.data;
  },
  // Get organization admins
  getOrgAdmins: async () => {
    const response = await api.get("/org-admins");
    return response.data;
  },
  // Get demo requests
  getDemoRequests: async () => {
    const response = await api.get("/get-demo-requests");
    return response.data;
  },
  // Create new organization admin
  createOrgAdmin: async (formData) => {
    const response = await api.post("/create_new_org_admin", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },
  // Update demo status
  updateDemoStatus: async (demoId, status) => {
    const response = await api.put(
      `/update-demo-status/${demoId}/${status}`,
      {}
    );
    return response.data;
  },

  // ==================== IMPERSONATION SERVICES ====================

  // Get all users that can be impersonated (Company Admins and HRs)
  getImpersonatableUsers: async () => {
    const response = await api.get("/admin/impersonation/users");
    return response.data;
  },

  // Start impersonation session
  startImpersonation: async (userType, userId, verificationPayload = null) => {
    const response = await api.post(
      `/admin/impersonate/${userType}/${userId}`,
      verificationPayload || {}
    );
    return response.data;
  },

  // Exit impersonation session
  exitImpersonation: async (impersonationToken) => {
    const response = await api.post("/admin/exit-impersonation", {}, {
      headers: { "X-Impersonation-Token": impersonationToken }
    });
    return response.data;
  },

  // Get org config for a specific org admin
  getOrgConfig: async (orgAdminId) => {
    const response = await api.get(`/admin/org-config/${orgAdminId}`);
    return response.data;
  },

  // Update org config flags for a specific org admin
  updateOrgConfig: async (orgAdminId, { liveAvatarEnabled, interactivityEnabled, interviewV1Animation, testPermissions }) => {
    const response = await api.post(
      `/admin/org-config/${orgAdminId}`,
      null,
      {
        params: {
          live_avatar_enabled: liveAvatarEnabled,
          interactivity_enabled: interactivityEnabled,
          interview_v1_animation: interviewV1Animation,
          mcq_enabled: testPermissions.mcq_enabled,
          coding_enabled: testPermissions.coding_enabled,
          behavioral_enabled: testPermissions.behavioral_enabled,
          typing_enabled: testPermissions.typing_enabled,
        }
      }
    );
    return response.data;
  },
};
